import * as angular from "angular";
import { VoterFileDataProvider } from "../../data-provider/voter-file.dp";
import { VoterFileImport } from "../../models/voter-file-import.model";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";

let EditImportName = {
    selector: "vcEditImportName",
    templateUrl:
        "/angular/components/voter-file/edit-import-name.component.html",
    bindings: {
        import: "=",
        backendUpdate: "=?",
    },
    controller: class EditCampaignController {
        // * bindings for typescript compiler *
        public import: VoterFileImport;
        public backendUpdate: boolean = true;
        // ************************************

        public saving: boolean = false;
        public importName: string;
        private dialog: DialogUtils;
        private toast: ToastUtils;

        private dataProvider: VoterFileDataProvider;

        constructor(
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            VoterFileDataProvider: VoterFileDataProvider
        ) {
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
            this.dataProvider = VoterFileDataProvider;
        }

        $onInit() {
            this.importName = this.import.name();
        }

        cancel(): void {
            this.dialog.cancel();
        }

        updateImportName(importName: string): void {
            this.saving = true;
            this.import.imname = importName;
            if (this.backendUpdate) {
                this.dataProvider
                    .updateImport(this.import)
                    .then((json: any) => {
                        this.saving = false;
                        if (json.success) {
                            this.toast.success("Import Name Updated");
                            this.dialog.hide(this.import);
                        } else {
                            this.toast.error();
                        }
                    });
            } else {
                this.dialog.hide(this.import);
            }
        }
    },
};

angular.module("voterFile").component(EditImportName.selector, EditImportName);
